export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const APIEndPoints = {
    User: API_BASE_URL + "/users",
    UserLogin: API_BASE_URL + "/users/login",
    UserCreate: API_BASE_URL + "/admin/users/create",
    UserSignup: API_BASE_URL + "/users/signup",
    VerifyEmail: API_BASE_URL + "/users/verify-email/{0}",
    ForgotPassword: API_BASE_URL + "/users/forgot-password",
    VerifyPasswordResetToken: API_BASE_URL + "/users/verify-password-reset-token",
    ResetPassword: API_BASE_URL + "/users/reset-password",
    UserDetails: API_BASE_URL + "/users/{0}",
    Campaign: API_BASE_URL + "/campaigns",
    MorePublicCampaigns: API_BASE_URL + "/campaigns/published",
    DonatedCampaign: API_BASE_URL + "/campaigns/donated",
    CampaignTopDonors: API_BASE_URL + "/campaigns/{0}/top-donors",
    GetImage: API_BASE_URL + "/images/{0}",
    GetReportContent: API_BASE_URL + "/reports/download/{0}",
    DeservingPatientList: API_BASE_URL + "/deserving-patients",
    GetReportDetails: API_BASE_URL + "/reports/{0}",
    ActiveDeservingItem: API_BASE_URL + "/active-deserving-items",
    DeservingItem: API_BASE_URL + "/deserving-items",
    DeservingItemDetails: API_BASE_URL + "/deserving-items/{0}",
    Donor: API_BASE_URL + "/donors",
    GetDonorFundedCampaignList: API_BASE_URL + "/donors/{0}/funded-campaigns",
    GetTotalDonor: API_BASE_URL + "/donors/total-donor",
    GetFundedPatientNumber: API_BASE_URL + "/donors/total-funded-patient",
    GetFundedItemNumber: API_BASE_URL + "/donors/total-funded-item",
    FundedPatientList: API_BASE_URL + "/donors/{0}/funded-patients",
    FundedItemList: API_BASE_URL + "/donors/{0}/funded-items",
    Donation: API_BASE_URL + "/donations",
    CompleteAbandonedDonation: API_BASE_URL + "/complete-abandoned-donations",
    CancelAbandonedDonation: API_BASE_URL + "/cancel-abandoned-donations",
    GetDonorTotalDonation: API_BASE_URL + "/donations/donor-total-amount",
    UserDonations: API_BASE_URL + "/users/{0}/donations",
    UserAbandonedDonations: API_BASE_URL + "/users/{0}/abandoned-donations",
    UserDonationsOverview: API_BASE_URL + "/users/{0}/donations/overview",
    DonationDetails: API_BASE_URL + "/donations/{0}",
    DonationPayments: API_BASE_URL + "/donations/{0}/payments",
    GetTotalDonation: API_BASE_URL + "/donations/total-amount",
    ConfirmDonation: API_BASE_URL + "/donations/confirm/{0}",
    GetCanceledDonationNumber: API_BASE_URL + "/donations/canceled-donation-number",
    Report: API_BASE_URL + "/reports",
    Note: API_BASE_URL + "/notes",
    GetDonorPaymentList: API_BASE_URL + "/payments",
    PaymentDetails: API_BASE_URL + "/payments/{0}",
    OfflinePaymentList: API_BASE_URL + "/payments/offline-payments",
    SendEmail: API_BASE_URL + "/emails/send",
    RefundRequest: API_BASE_URL + "/refund-requests",
    GetRefundRequest: API_BASE_URL + "/refund-requests/{0}",
    Patient: API_BASE_URL + "/patients",
    PatientDetails: API_BASE_URL + "/patients/{0}",
    ApproveRefundRequest: API_BASE_URL + "/refund-requests/approve",
    RejectRefundRequest: API_BASE_URL + "/refund-requests/reject",
};
